import { defineRouter } from '#q-app/wrappers'
import { createRouter, createMemoryHistory, createWebHistory, createWebHashHistory } from 'vue-router'
import routes from './routes'
import authMiddleware from './middleware/auth'
import checkDevice from 'src/router/middleware/check-device.js'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default defineRouter(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory)

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE)
  })

  Router.beforeEach(async (to, from, next) => {
    // Создаем обертку для next() чтобы передавать управление между middleware
    let redirected = false

    const redirect = (path) => {
      redirected = true
      next(path)
    }

    const nextWrapper = () => {
      if (!redirected) {
        next()
      }
    }

    try {
      // Сначала проверяем устройство
      await checkDevice({ to, from, next: redirect, router: Router })

      // Если не было редиректа, продолжаем с authMiddleware
      if (!redirected) {
        await authMiddleware({ to, from, next: nextWrapper })
      }
    } catch (error) {
      console.error('Middleware error:', error)
      next()
    }
  })
  return Router
})
